"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNativeWeb = require("react-native-web");

var _reactDom = _interopRequireDefault(require("react-dom"));

var _StyleSheet = _interopRequireDefault(require("../../PlatformStyleSheet/StyleSheet"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Modal = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Modal, _React$Component);

  var _super = _createSuper(Modal);

  function Modal() {
    var _this;

    (0, _classCallCheck2["default"])(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "modalElement", null);
    return _this;
  }

  (0, _createClass2["default"])(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.modalElement) {
        this.modalElement = document.createElement('div');
        this.modalElement.setAttribute("id", "aa-modal-mobile-view");
      }

      if (document.body) {
        document.body.appendChild(this.modalElement);
        this.forceUpdate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.modalElement && document.body) {
        document.body.removeChild(this.modalElement);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          isVisible = _this$props.isVisible,
          style = _this$props.style,
          backdropColor = _this$props.backdropColor,
          backdropOpacity = _this$props.backdropOpacity,
          onBackdropPress = _this$props.onBackdropPress;

      if (!isVisible) {
        return null;
      }

      var dynamicStyle = _StyleSheet["default"].create({
        backdrop: {
          opacity: backdropOpacity || 0.5,
          backgroundColor: backdropColor
        }
      });

      if (this.modalElement) {
        return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/React.createElement(_reactNativeWeb.View, {
          style: [styles.overlay, style]
        }, /*#__PURE__*/React.createElement(_reactNativeWeb.TouchableWithoutFeedback, {
          onPress: onBackdropPress,
          testID: "backdrop"
        }, /*#__PURE__*/React.createElement(_reactNativeWeb.View, {
          style: [styles.backdrop, dynamicStyle.backdrop]
        })), children), this.modalElement);
      }

      return null;
    }
  }]);
  return Modal;
}(React.Component);

exports["default"] = Modal;

var styles = _StyleSheet["default"].create({
  overlay: {
    web: {
      position: 'fixed',
      overflowY: 'auto'
    },
    width: '100%',
    height: '100%',
    top: 0,
    start: 0,
    // alignItems: 'center',
    // justifyContent: 'center',
    zIndex: parseInt(100000, 10)
  },
  backdrop: {
    height: '100%',
    width: '100%',
    web: {
      position: 'fixed'
    }
  }
});